import './keypad.scss'
import Backspace from '../../../assets/images/icons/backspace.png'
import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import { topLimitAmount } from '../../home/amount/homeAmount'

interface DifferentBtn {
    icon: ReactElement
    fn: (oldVal: number) => string
}

type BtnType = number | null | DifferentBtn

const removeDigit = (n: number): string => {
    const str = n.toString()
    return str.slice(0, str.length - 1)
}
const addDigit = (newDigit: number) => (n: number): string => {
    
    if (Number(n) < topLimitAmount) {
        return n.toString() + newDigit.toString()
    }
    return n.toString();
    
}
const deleteDigit: BtnType = { icon: <img src={Backspace} alt='Limpar' />, fn: removeDigit }
const btnsArray: BtnType[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, deleteDigit]

interface Props {
    value?: number
    onChange: (n: number) => void
    className?: string,
    disabled?: boolean
}

export const Keypad: React.FC<Props> = ({ value, onChange, className, disabled }) => {
    const [val, setVal] = useState(0);

    useEffect(() => {
        if (!value || val === value) return
        setVal(value)
    }, [val, value])

    const onVal = useCallback(
        (fn: (n: number) => number | string) => {
            setVal((prev) => {
                const newVal = Number(fn(prev));
                if (!isNaN(newVal) && newVal <= (topLimitAmount*10)) {
                    onChange(newVal);
                    return newVal;
                }
                return prev;
            });
        },
        [onChange]
    );

    const renderBtn = (btn: BtnType, i: number) => {

        if (btn === null) return <span key={i}></span>

        const func = (btn as DifferentBtn)?.fn || addDigit(btn as number)
        const digit = (btn as DifferentBtn)?.icon || (btn as number)

        const isDisabled = val > topLimitAmount;

        return (
            <span key={i} 
                onClick={() => {
                    if (i !==11) !isDisabled && onVal(func)
                    else onVal(func)
                }} 
                className={`digit-btn ${isDisabled && i !== 11? 'disabled' : null} `}>
                {digit}
            </span>
        )
    }

    return <div className={`keypad ${className}`}>{btnsArray.map(renderBtn)}</div>
}
